/** One entry per API `rules` shape; extend when new rules are added. */
export const CAMPAIGN_RULE_OPTIONS = [
  {
    id: 'waive_dealing_charges',
    label: 'Waive dealing charges',
    rules: { waive_dealing_charges: true as const },
  },
] as const

export type CampaignRuleId = typeof CAMPAIGN_RULE_OPTIONS[number]['id']

export type CampaignFormValues = {
  code: string
  description: string
  ruleId: CampaignRuleId
  is_active: boolean
  valid_from: string
  valid_until: string
  max_redemptions: string
}

export const campaignFormDefaultValues: CampaignFormValues = {
  code: '',
  description: '',
  ruleId: 'waive_dealing_charges',
  is_active: true,
  valid_from: '',
  valid_until: '',
  max_redemptions: '',
}
